import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Entrevista from './pages/Entrevista';
import RevistaCeara from './pages/RevistaCeara';
import ReportagemCeara from './pages/ReportagemCeara';
import RepercussaoNacional from './pages/RepercussaoNacional';
import AltoAlcance from './pages/AltoAlcance';
import AltoAlcanceX from './pages/AltoAlcanceX';
import ReportagemR8 from './pages/ReportagemR8';
import Laudo from './pages/Laudo';
import Liberal from './pages/Liberal';
import LeMonde from './pages/LeMonde';
import Fnn from './pages/Fnn';
import AmazoniaReal from './pages/AmazoriaReal';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/entrevistas" element={<Entrevista />} /> */}
        <Route path="/revista/ceara" element={<RevistaCeara />} />
        <Route path="/reportagens/ceara" element={<ReportagemCeara />} />
        <Route path="/reportagens/repercussao-nacional" element={<RepercussaoNacional />} />
        <Route path="/reportagens/alto-alcance" element={<AltoAlcance />} />
        <Route path="/reportagens/alto-alcance-x" element={<AltoAlcanceX />} />
        <Route path="/reportagens/r8" element={<ReportagemR8 />} />
        <Route path="/documentos/laudo" element={<Laudo />} />
        <Route path="/veiculos/liberal" element={<Liberal />} />
        <Route path="/veiculos/le-monde" element={<LeMonde />} />
        <Route path="/veiculos/fnn" element={<Fnn />} />
        <Route path="/veiculos/amazonia-real" element={<AmazoniaReal />} />
      </Routes>
    </Router>
  );
};

export default App;